import React from "react";
import { Grid, Typography } from "@mui/material";
import request from "../../../../utilities/requests";

import UserStats from "./UserStats";
import Filters from "./Filters";
import SearchResults from "./SearchResults";
import UserDialog from "./UserDialog/UserDialog";

const Users = ({questions}) => {
    const [users, setUsers] = React.useState([]);
    const [searching, setSearching] = React.useState(false);
    const [userDialogOpen, setUserDialogOpen] = React.useState(false);
    const [selectedUser, setSelectedUser] = React.useState(null); 

    const handleSearch = async (filters) => {
        setSearching(true);
        const result = await request('matchmaking/search', 'post', {filters})
        if (result.success) {
            setUsers(result.users)
        }
        setSearching(false);
    }

    const handleOpenUser = (user) => {
        setSelectedUser(user);

    }


return (
<Grid container spacing={3}>
    <Grid item xs={12}>
        <UserStats search={handleSearch}/>
    </Grid>
    <Grid item xs={12}>
        <Filters questions={questions} search={handleSearch}/>
    </Grid>
    <Grid item xs={12}>
        <SearchResults users={users} searching={searching} openUser={handleOpenUser}/>
    </Grid>
    <UserDialog close={() => setSelectedUser(null)} user={selectedUser}/>
</Grid>
    )


}

export default Users